import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WmTransitionModule } from '../transition/index';
import { SpinnerComponent } from './spinner.component';

@NgModule({
	declarations: [SpinnerComponent],
	imports: [CommonModule, WmTransitionModule],
	exports: [SpinnerComponent]
})
export class WmSpinnerModule {}
